import { POST, POSTNEW, UPLOADINGNEW, EXPORTNEW, GETNEW, POSTFormDataNEW } from '@/request/http'


// 创建通知
export const createNotice = p => POSTNEW('/backlog/notice/insertNoticeInfo', p)

// 获取通知详情数据
export const getNoticeDataDetail = p => GETNEW('/backlog/notice/getDetailById', p)

// 获取通知类型接口
export const getNoticeType = p => GETNEW('/backlog/notice_config/getInfoByCollegeId', p)

// 编辑通知信息
export const getNoticeData = p => GETNEW('/backlog/notice/getDetailById', p)

// 通知信息表格
export const getNoticeTabelData = p => POSTNEW('/backlog/notice/page', p)

// 获取关联信息
export const getNoticeAssociationData = p => GETNEW('/backlog/notice_association/getInfoByCollegeId', p)

// 获取名单导入的scopeValue
export const getNoticeNameListID = p => GETNEW('/backlog/notice_person/getGuid', p)

// 通知名单导入(学生)
export const importNoticeNameList = p => POSTFormDataNEW('/backlog/notice_person/importExport', p)

// 通知名单导入(老师)
export const importNoticeNameListTEA = p => POSTFormDataNEW('/backlog/notice_person/importExportTeacher', p)

// 通知名单导入表格信息
export const getImportNoticeNameListTabelData = p => POSTNEW('/backlog/notice_person/getPage', p)

// 通知名单导入表格信息
export const getImportNoticeNameListTabelDataTEA = p => POSTNEW('/backlog/notice_person/getNoticePersonPage', p)

// 移除通知名单导入信息
export const removeNoticeNameList = p => POSTNEW('/backlog/notice_person/removePerson', p)

// 获取老师范围选项值
export const getNoticeTEARangeData = p => GETNEW('/backlog/notice_person/teacherList', p)

// 通知失效操作
export const noticeLoseEfficacy = p => POSTNEW('/backlog/notice/updateOpenSwitch', p)

// 获取收到的通知
export const getReceiveNotice = p => POSTNEW('/backlog/backlog-info/notice-page/TEA', p)

// 获取通知待办信息未读角标
export const getUnreadAubscript = p => POSTNEW('/backlog/backlog-info/notice-count/TEA', p)

// 处理通知待办信息未读角标
export const handleUnreadAubscript = p => POST('/backlog/backlog-info/processByNoticeId', p)

// 群聊接口
// 获取发通知人员（老师）
export const getSendNoticeList = p => POSTNEW('/studentv2/manage-permission/pageStudentManage', p)

// 获取职务信息
export const getDutiesList = p => POSTNEW('/studentv2/manage-permission/listStudentManagePost', p)

// 创建群聊
export const createGroupChat = p => POSTNEW('/backlog/notice/group/save', p)

// 编辑群聊
export const editGroupChat = p => POSTNEW('/backlog/notice/group/update', p)

// 获取群聊列表
export const getGroupChatList = p => POSTNEW('/backlog/notice/group/page', p)

// 修改群聊状态
export const changeGroupChatStatus = p => POSTNEW('/backlog/notice/group/updateNoticeGroupStatus', p)

// 删除群聊
export const delGroupChat = p => POSTNEW('/backlog/notice/group/remove', p)

// 编辑群聊获取详情
export const getGroupChatDetial = p => POSTNEW('/backlog/notice/group/getOne', p)

// 通知接口
// 查看某个群聊通知
export const getGroupChatNoticeList = p => POSTNEW('/backlog/notice/pageV2', p)

// 发送通知
export const sendGroupChatNotice = p => POSTNEW('/backlog/notice/insertNoticeInfoByGroup', p)

// 修改通知失效状态
export const changeNoticeEfficacyStatus = p => POSTNEW('/backlog/notice/updateOpenSwitchV2', p)

// 编辑通知
export const editGroupChatNotice = p => POSTNEW('/backlog/notice/updateNoticeInfoByGroup', p)

// 编辑通知获取详情
export const getGroupChatNoticeDetial = p => POSTNEW('/backlog/notice/getNoticeInfoV2', p)


// WEBPACK FOOTER //
// ./src/api/modules/notice.js